import {
    Box,
    Container,
    Typography,
    Grid,
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    useTheme,
    useMediaQuery,
  } from "@mui/material";
  import React from "react";
  import { useTranslation } from "react-i18next";
  import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
  import PTTranslate from "../../../../common/components/ui/PTTranslate";
  import { ProductIntro } from "../../../../asset/images/LandingPage";
  
  const ProductIntroSection = () => {
    const theme = useTheme();
    const { t } = useTranslation();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    
    const productBenefits = [
      "productIntro.feature1",
      "productIntro.feature2",
      "productIntro.feature3",
      "productIntro.feature4",
      "productIntro.feature5",
    ];
  
    return (
      <Box
        sx={{
          py: { xs: 6, md: 10 },
          bgcolor: '#ffffff',
          width: '100%',
        }}
      >
        <Container maxWidth="lg">
          {/* Increased spacing between grid items */}
          <Grid container spacing={{ xs: 6, md: 8 }} alignItems="center">
            {/* Text content - increased width to take up more space */}
            <Grid item xs={12} md={7}>
              <Typography
                variant="h2"
                component="h2"
                sx={{
                  fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
                  fontWeight: 700,
                  mb: 3,
                  color: '#1a237e',
                  lineHeight: 1.2,
                }}
              >
                <PTTranslate tk="productIntro.title" />
              </Typography>
              
              <Typography
                variant="body1"
                sx={{
                  fontSize: { xs: '1rem', sm: '1.1rem', md: '1.2rem' },
                  color: 'text.primary',
                  mb: 3,
                  lineHeight: 1.5,
                  width: { md: '90%' }, // Make text slightly narrower for better readability
                }}
              >
                <PTTranslate tk="productIntro.description" />
              </Typography>
              
              <List sx={{ mb: 3 }}>
                {productBenefits.map((benefit, index) => (
                  <ListItem 
                    key={index} 
                    sx={{ 
                      py: 0.5,
                      px: 0
                    }}
                  >
                    <ListItemIcon sx={{ minWidth: 24 }}>
                      <FiberManualRecordIcon 
                        sx={{ 
                          fontSize: 8,
                          color: 'text.primary'
                        }} 
                      />
                    </ListItemIcon>
                    <ListItemText 
                      primary={
                        <Typography 
                          variant="body1" 
                          sx={{ 
                            fontSize: { xs: '0.95rem', md: '1.05rem' } 
                          }}
                        >
                          <PTTranslate tk={benefit} />
                        </Typography>
                      } 
                    />
                  </ListItem>
                ))}
              </List>
              
              <Typography
                variant="body1"
                sx={{
                  fontSize: { xs: '1rem', sm: '1.1rem' },
                  color: 'text.primary',
                  fontWeight: 500,
                }}
              >
                <PTTranslate tk="productIntro.conclusion" />
              </Typography>
            </Grid>
            
            {/* Image section - reduced width */}
            <Grid item xs={12} md={5} sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-end' } }}>
              <Box
                sx={{
                  width: { xs: '100%', sm: '90%', md: '85%' }, // Reduced width for the image container
                  height: { xs: '350px', sm: '450px', md: '550px', lg: '600px' },
                  borderRadius: 7,
                  overflow: 'hidden',
                  boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                }}
              >
                <Box
                  component="img"
                  src={ProductIntro}
                  alt="Product certification process"
                  sx={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    borderRadius: '8px',
                    transition: 'transform 0.3s ease-in-out',
                    '&:hover': {
                      transform: 'scale(1.02)',
                    },
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    );
  };
  
  export default ProductIntroSection;